export default __webpack_public_path__ + "static/media/delay-light.a8ab6d82.svg";